$(document).ready(function () {
  // Convert navigation parent links into buttons
  var checkExist = setInterval(function () {
    var $links = $(".navigation__item--with-children > a");

    if ($links.length) {
      $links.removeAttr("href").attr({
        role: "button",
        tabindex: "0",
      });

      clearInterval(checkExist);
    }
  }, 100);

  // Remove invalid aria-describedby from Rebuy quick view overlay
  $("div#rebuy-quick-view-overlay").removeAttr("aria-describedby");

  // Remove invalid Slick ARIA roles from track and slides after Slick initializes
  function fixSlickRoles() {
    setTimeout(function () {
      $('.slick-track[role="listbox"]').removeAttr("role aria-label");
      $('.slick-slide[role="option"]').removeAttr("role");
    }, 800);
  }

  fixSlickRoles();

  $(document).on(
    "init reInit afterChange setPosition",
    ".slick-slider",
    function () {
      fixSlickRoles();
    },
  );

  // Add empty alt attribute to product description images
  setTimeout(function () {
    $(
      ".product-description.rte.container.cf.padded-row.not-in-quickbuy img",
    ).attr("alt", "");
  }, 200);

  //slick slide dots
  function hideSlickDotsAccessibly() {
    $(".slick-dots").attr("aria-hidden", "true").find("button, a").attr({
      tabindex: "-1",
      "aria-hidden": "true",
    });
  }

  hideSlickDotsAccessibly();

  $(document).on(
    "init reInit afterChange setPosition",
    ".slick-slider",
    function () {
      setTimeout(hideSlickDotsAccessibly, 300);
    },
  );

  // adding attributes
  function addNavigationAttributes() {
    $(".navigation__link.navigation__column-title").attr({
      role: "button",
      tabindex: "0",
      "aria-expanded": "false",
    });

    $(".navigation__children-toggle.mobile-toggle").attr({
      role: "button",
      tabindex: "0",
      "aria-expanded": "false",
    });
  }

  setTimeout(addNavigationAttributes, 1000);
  setTimeout(addNavigationAttributes, 2000);
  $(window).on("load", addNavigationAttributes);
  function setMenuA11y($menu, isOpen) {
    if (!$menu.length) return;

    $menu.attr("aria-hidden", String(!isOpen));

    $menu
      .find("a, button, input, select, textarea, [tabindex]")
      .attr("tabindex", isOpen ? "0" : "-1");
  }
  // Tier-3 menu: click, keyboard and Escape support
  (function () {
    var tier3TriggerSelector =
      "#main-nav .navigation__tier-2 > " +
      ".navigation__item--with-children > " +
      ".navigation__column-title";

    var openItemSelector =
      "#main-nav .navigation__tier-2 > " +
      ".navigation__item--with-children.navigation__item--open";

    var lastTier3Trigger = null;

    function getDirectTier3Menu($item) {
      return $item.children(".navigation__tier-3-container");
    }

    function updateItemState($item, isOpen) {
      var $title = $item.children(".navigation__column-title");

      var $mobileToggle = $item.children(
        ".navigation__children-toggle.mobile-toggle",
      );

      var $tier3Menu = getDirectTier3Menu($item);

      $item.toggleClass("navigation__item--open", isOpen);

      $title.add($mobileToggle).attr("aria-expanded", String(isOpen));

      setMenuA11y($tier3Menu, isOpen);

      if (isOpen) {
        $tier3Menu.css("height", "auto");
      } else {
        $tier3Menu.css("height", "");
      }
    }

    function closeTier3Menus($excludedItem, restoreFocus) {
      $(openItemSelector).each(function () {
        var $item = $(this);

        if ($excludedItem && $excludedItem.length && $item.is($excludedItem)) {
          return;
        }

        updateItemState($item, false);
      });

      if (restoreFocus && lastTier3Trigger && lastTier3Trigger.length) {
        lastTier3Trigger.trigger("focus");
      }

      if (!$excludedItem || !$excludedItem.length) {
        lastTier3Trigger = null;
      }
    }

    function toggleTier3($trigger) {
      var $item = $trigger.closest(
        ".navigation__tier-2 > " + ".navigation__item--with-children",
      );

      var $tier3Menu = getDirectTier3Menu($item);

      if (!$tier3Menu.length) {
        return;
      }

      var shouldOpen = !$item.hasClass("navigation__item--open");

      closeTier3Menus($item, false);
      updateItemState($item, shouldOpen);

      if (shouldOpen) {
        lastTier3Trigger = $trigger;
      } else {
        $trigger.trigger("focus");
        lastTier3Trigger = null;
      }
    }

    // Initialize tier-3 accessibility state.
    $(tier3TriggerSelector).each(function () {
      var $trigger = $(this);
      var $item = $trigger.parent();
      var $tier3Menu = getDirectTier3Menu($item);

      $trigger.attr({
        role: "button",
        tabindex: "0",
        "aria-haspopup": "true",
        "aria-expanded": "false",
      });

      setMenuA11y($tier3Menu, false);
    });

    // Mouse click.
    $(document).on(
      "click.accessibilityTier3",
      tier3TriggerSelector,
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        toggleTier3($(this));
      },
    );

    // Enter and Space keys.
    $(document).on(
      "keydown.accessibilityTier3",
      tier3TriggerSelector,
      function (event) {
        var isEnter = event.key === "Enter" || event.keyCode === 13;

        var isSpace =
          event.key === " " || event.key === "Spacebar" || event.keyCode === 32;

        if (!isEnter && !isSpace) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        toggleTier3($(this));
      },
    );

    // Escape closes tier 3 and returns focus.
    $(document).on("keydown.accessibilityTier3Escape", function (event) {
      var isEscape =
        event.key === "Escape" || event.key === "Esc" || event.keyCode === 27;

      if (!isEscape) {
        return;
      }

      if (!$(openItemSelector).length) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      closeTier3Menus(null, true);
    });

    // Close when clicking outside tier 3.
    $(document).on("click.accessibilityTier3Outside", function (event) {
      if (
        $(event.target).closest(
          "#main-nav .navigation__tier-2 > " +
            ".navigation__item--with-children",
        ).length
      ) {
        return;
      }

      closeTier3Menus(null, false);
    });
  })();
  // Top-level desktop nav: keyboard-accessible open/close without focus-only opening.
  (function () {
    var topTriggerSelector =
      "#main-nav .navigation__tier-1 > " +
      ".navigation__item--with-children > a[role='button']";

    var openTopItemSelector =
      "#main-nav .navigation__tier-1 > " +
      ".navigation__item--with-children.navigation__item--show-children";

    var lastTopTrigger = null;

    function closeTopMenus(excludedItem, restoreFocus) {
      $(openTopItemSelector).each(function () {
        var $item = $(this);

        if (excludedItem && excludedItem.length && $item.is(excludedItem)) {
          return;
        }

        $item.removeClass("navigation__item--show-children");
        $item.data("hoverOpened", false);
        $item.children("a[role='button']").attr("aria-expanded", "false");
        setMenuA11y($item.children(".navigation__tier-2-container"), false);
      });

      if (restoreFocus && lastTopTrigger && lastTopTrigger.length) {
        lastTopTrigger.trigger("focus");
      }

      if (!excludedItem || !excludedItem.length) {
        lastTopTrigger = null;
      }
    }

    function toggleTopMenu(trigger) {
      var $trigger = $(trigger);
      var $item = $trigger.parent(".navigation__item--with-children");
      var shouldOpen = !$item.hasClass("navigation__item--show-children");

      closeTopMenus($item, false);

      $item.toggleClass("navigation__item--show-children", shouldOpen);
      $trigger.attr("aria-expanded", String(shouldOpen));
      setMenuA11y($item.children(".navigation__tier-2-container"), shouldOpen);

      lastTopTrigger = shouldOpen ? $trigger : null;
    }

    $(topTriggerSelector).attr("aria-expanded", "false");

    document.addEventListener(
      "click",
      function (event) {
        var trigger = event.target.closest(topTriggerSelector);

        if (!trigger) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        // A click on a menu that hover just opened pins it open instead of
        // closing it under the pointer.
        var $hoverItem = $(trigger).parent(".navigation__item--with-children");
        if (
          $hoverItem.data("hoverOpened") &&
          $hoverItem.hasClass("navigation__item--show-children")
        ) {
          $hoverItem.data("hoverOpened", false);
          lastTopTrigger = $(trigger);
          return;
        }

        toggleTopMenu(trigger);
      },
      true,
    );

    document.addEventListener(
      "keydown",
      function (event) {
        var isEnter = event.key === "Enter" || event.keyCode === 13;
        var isSpace =
          event.key === " " || event.key === "Spacebar" || event.keyCode === 32;
        var isEscape = event.key === "Escape" || event.keyCode === 27;

        if (isEnter || isSpace) {
          var trigger = event.target.closest(topTriggerSelector);

          if (!trigger) {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();

          toggleTopMenu(trigger);
          return;
        }

        if (!isEscape || !$(openTopItemSelector).length) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        closeTopMenus(null, true);
      },
      true,
    );

    document.addEventListener(
      "click",
      function (event) {
        if (
          event.target.closest("#main-nav .navigation__item--with-children")
        ) {
          return;
        }

        closeTopMenus(null, false);
      },
      true,
    );
    // Hover-to-open on devices with a real hover pointer (mouse/trackpad).
    // Short delays stop flicker and let the pointer travel into the dropdown.
    var hoverQuery = window.matchMedia
      ? window.matchMedia("(hover: hover) and (pointer: fine)")
      : null;
    var desktopQuery = window.matchMedia
      ? window.matchMedia("(min-width: 768px)")
      : null;
    var hoverDelay = 150;
    var topItemSelector =
      "#main-nav .navigation__tier-1 > .navigation__item--with-children";

    function hoverEnabled() {
      return !!(
        hoverQuery &&
        hoverQuery.matches &&
        desktopQuery &&
        desktopQuery.matches
      );
    }

    function openTopMenuByHover($item) {
      if ($item.hasClass("navigation__item--show-children")) return;
      var $trigger = $item.children("a[role='button']");
      closeTopMenus($item, false);
      $item.addClass("navigation__item--show-children");
      $item.data("hoverOpened", true);
      $trigger.attr("aria-expanded", "true");
      setMenuA11y($item.children(".navigation__tier-2-container"), true);
      lastTopTrigger = $trigger;
    }

    function closeTopMenuByHover($item) {
      if (!$item.data("hoverOpened")) return;
      $item.data("hoverOpened", false);
      $item.removeClass("navigation__item--show-children");
      $item.children("a[role='button']").attr("aria-expanded", "false");
      setMenuA11y($item.children(".navigation__tier-2-container"), false);
    }

    $(document)
      .on("mouseenter", topItemSelector, function () {
        if (!hoverEnabled()) return;
        var $item = $(this);
        clearTimeout($item.data("hoverCloseTimer"));
        clearTimeout($item.data("hoverOpenTimer"));
        $item.data(
          "hoverOpenTimer",
          setTimeout(function () {
            openTopMenuByHover($item);
          }, hoverDelay),
        );
      })
      .on("mouseleave", topItemSelector, function () {
        var $item = $(this);
        clearTimeout($item.data("hoverOpenTimer"));
        if (!hoverEnabled()) return;
        $item.data(
          "hoverCloseTimer",
          setTimeout(function () {
            closeTopMenuByHover($item);
          }, hoverDelay),
        );
      });
  })();
});

// Header nav fit check. CSS shows the hamburger below 1280px. At 1280px and
// up, collapse to the hamburger too if the top-level row would not fit on one
// line (html.nav-collapsed), e.g. after longer menu labels are added.
(function () {
  var BREAKPOINT = 1280;
  var root = document.documentElement;
  var queued = false;

  function check() {
    queued = false;
    var tier1 = document.querySelector("#main-nav .navigation__tier-1");
    if (!tier1) return;

    if (window.innerWidth < BREAKPOINT) {
      root.classList.remove("nav-collapsed");
      return;
    }

    // Measure the uncollapsed row synchronously (no paint in between).
    root.classList.remove("nav-collapsed");
    var overflows = tier1.scrollWidth > tier1.clientWidth + 1;
    if (!overflows) {
      var items = tier1.children;
      if (items.length > 1) {
        var top = items[0].offsetTop;
        for (var i = 1; i < items.length; i++) {
          if (Math.abs(items[i].offsetTop - top) > 4) {
            overflows = true;
            break;
          }
        }
      }
    }
    root.classList.toggle("nav-collapsed", overflows);
  }

  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(check, 50);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", check);
  } else {
    check();
  }
  window.addEventListener("load", queue);
  window.addEventListener("resize", queue);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(queue);
  }
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(queue);
    var header = document.querySelector(".section-header") || document.body;
    ro.observe(header);
    var navItems = document.querySelectorAll(
      "#main-nav .navigation__tier-1 > .navigation__item",
    );
    for (var j = 0; j < navItems.length; j++) ro.observe(navItems[j]);
  }
})();

// Drawer help links that open an overlay in place (sign-in slideout, chat)
// close the drawer first so the overlay is not hidden behind it.
document.addEventListener("click", function (event) {
  var link = event.target.closest(".drawer-utility-links a[href^='#']");
  if (!link || !document.body.classList.contains("reveal-mobile-nav")) return;
  var close = document.querySelector(
    ".mobile-navigation-drawer .navigation__mobile-header .mobile-nav-toggle",
  );
  if (close) {
    setTimeout(function () {
      close.click();
    }, 0);
  }
}, true);
